<script setup lang="ts">
  import { ref, type HTMLAttributes } from 'vue'
  import { cn } from '../../../lib/utils'
  import { Input } from '../input'

  const props = defineProps<{
    class?: HTMLAttributes['class']
    /**
     * Forwarded to the inner `Input`, which consumes `maxLength` as a prop
     * (not a native attribute). Declared explicitly so it's typed for
     * intellisense and reliably reaches the prop rather than relying on
     * attribute fallthrough. (`<textarea>` has no such prop — use the
     * native `maxlength` attribute on `InputGroupTextarea` instead.)
     */
    maxLength?: number
  }>()

  const inputRef = ref<InstanceType<typeof Input> | null>(null)

  defineExpose({
    focus: () => inputRef.value?.focus()
  })
</script>

<template>
  <Input
    ref="inputRef"
    data-slot="input-group-control"
    :max-length="props.maxLength"
    :class="
      cn(
        'flex-1 rounded-none border-0 bg-transparent shadow-none focus-visible:ring-0 dark:bg-transparent',
        props.class
      )
    "
  />
</template>
